const factory = () => ({ passengers: null });
export default {
    namespaced: true,
    state: factory(),
    mutations: {
        ResetState(state) {
            Object.assign(state, factory());
        }
    },
    getters: {},
    actions: {
        ResetState(context) {
            context.commit("ResetState");
        }
    }
};